// action - state management
import { LOGIN, LOGOUT, REGISTER, IMPERSONATE, EXIT_IMPERSONATION, UPDATE_PROFILE } from './actions';

const initialState = {
  isLoggedIn: false,
  isInitialized: false,
  isImpersonating: false,
  impersonatedBy: null,
  user: null
};

export default function accountReducer(state = initialState, action) {
  switch (action.type) {
    case REGISTER: {
      const { user } = action.payload;
      return {
        ...state,
        user
      };
    }
    case LOGIN: {
      const { user } = action.payload;
      return {
        ...state,
        isLoggedIn: true,
        isInitialized: true,
        isImpersonating: false,
        impersonatedBy: null,
        user
      };
    }
    case LOGOUT: {
      return {
        ...state,
        isInitialized: true,
        isLoggedIn: false,
        isImpersonating: false,
        impersonatedBy: null,
        user: null
      };
    }
    case IMPERSONATE: {
      const { user, impersonatedBy } = action.payload;
      return {
        ...state,
        isLoggedIn: true,
        isInitialized: true,
        isImpersonating: true,
        impersonatedBy,
        user
      };
    }
    case EXIT_IMPERSONATION: {
      const { user } = action.payload;
      return {
        ...state,
        isLoggedIn: true,
        isInitialized: true,
        isImpersonating: false,
        impersonatedBy: null,
        user
      };
    }
    case UPDATE_PROFILE: {
      const { user } = action.payload;
      return {
        ...state,
        user
      };
    }
    default: {
      return { ...state };
    }
  }
}
